<app-modal-generico [modelo]="modalGenerico">
  <article class="row bg-gray">
    <section class="col-12 mt-1">
      <div class="d-flex justify-content-between">
        <div>
          <img
            src="../../../../../assets/icons/solicitud.png"
            class="d-inline-block img-responsive mr-3"
            alt=""
          />
          <label class="h5">Listado de Usuarios</label>
        </div>
        <p>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="filtros"
          >
            Ver filtros
          </button>
        </p>
      </div>
      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Número identificación</label
                  >
                  <input
                    id="numero_identificacion"
                    formControlName="numero_identificacion"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Tipo de Usuario</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="tipo_usuario_id"
                    formControlName="tipo_usuario_id"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option
                      class=""
                      *ngFor="let option of tipoUsuario; let i = index"
                      value="{{ option?.tipo_usuario_id }}"
                      [selected]="false"
                    >
                      {{ option?.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Usuario</label>
                  <input
                    id="usuario"
                    formControlName="usuario"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Correo Electrónico</label
                  >
                  <input
                    id="correo_electronico"
                    formControlName="correo_electronico"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select
                    class="form-control form-control-sm"
                    id="activo"
                    formControlName="activo"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button
                    type="reset"
                    class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()"
                  >
                    Limpiar
                  </button>
                  <button
                    class="btn btn-primary m-auto solicitud-btn-principal"
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section
      class="col-12 mt-1 mb-1"
      *ngIf="dataTabla.paging.totalItems >= 1; else no_data"
    >
      <div class="table-responsive">
        <app-tablas
          [page]="paginaActual"
          [headers]="headerUsuarios"
          [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr
            *ngFor="let item of dataTabla.items; let i = index"
            class="small"
            (click)="selection(item)"
          >
            <td>
              <img
                src="../../../../../../../../assets/icons/checked_2.png"
                alt=""
                height="18"
                *ngIf="i !== dataTabla.items.indexOf(usuarioSeleccionado)"
              />
              <img
                src="../../../../../../../../assets/icons/checked.png"
                alt=""
                height="18"
                *ngIf="i === dataTabla.items.indexOf(usuarioSeleccionado)"
              />
            </td>
            <td>{{ item.numero_identificacion }}</td>
            <td>{{ item.desc_tipo_usuario }}</td>
            <td>{{ item.usuario }}</td>
            <td>{{ item.correo_electronico }}</td>
            <td>{{ item.fecha_creacion | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.activo ? "Activo" : "Inactivo" }}</td>
          </tr>
        </app-tablas>
      </div>
      <div class="form-row mb-3">
        <div class="col form-group text-center">
          <button
            type="button"
            class="btn btn-primary paso-capacidad w-100 mt-3"
            (click)="confirm()"
            [disabled]="!usuarioSeleccionado"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </section>
    <ng-template #no_data>
      <section class="col-12 p-4 mt-1 mb-1">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img
              class="img-fluid mb-5"
              src="../../../../../../../assets/images/sin_establecimiento.png"
            />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>
  </article>
</app-modal-generico>
